import React from "react";
import { useGetAllFavouritesWorkbookQuery } from "./GetfavoriteapiSlice";
import { useNavigate } from "react-router-dom";
import useTitle from "../hooks/useTitle";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoIosStar, IoMdInformationCircleOutline } from "react-icons/io";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { Dropdown, DropdownItem } from "flowbite-react";
import { useToggleFavoriteMutation } from "./libraryApiSlice";
import LoadingIndicator from "../components/BasicComponents/LoadingIndicator";
import { IoStarOutline } from "react-icons/io5";

export default function Fav() {
  useTitle("Vizta Favorites");
  const navigate = useNavigate();

  const {
    data: favoritePageData,
    isLoading,
    isError: isFavoritePageError,
    error: favoritePageError,
  } = useGetAllFavouritesWorkbookQuery();
  const [
    toggleFavorite,
    {
      data: toggleFavoriteMessage,
      isError: isToggleFavoriteError,
      isSuccess: isToggleFavoriteSuccess,
      isLoading: isToggleFavoriteLoading,
      error: toggleFavoriteError,
    },
  ] = useToggleFavoriteMutation();

  const handleOpenFolder = (id) => {
    // console.log(id);
    const folderPath = id ? id : "root";
    navigate(`/home/dash/library/${folderPath}`);
  };

  const handleOpenWorkbook = (workbookId, sheetId) => {
    if (workbookId && sheetId) {
      navigate(`/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
    } else {
      // console.log("selectedSheetId is null or undefined");
    }
  };
  const handleRemoveFromFavorite = (id, type) => {
    const request = {
      workbookOrFolderId: id,
      type: type,
    };
    // console.log(request);
    toggleFavorite(request);
  };
  // console.log(favoritePageData);
  // console.log(toggleFavoriteMessage);

  return (
    <section className="p-2  h-[94vh] min-h-[94vh] ">
      <section className="flex gap-2 items-center font-medium w-full justify-start p-1">
        <IoIosStar className="text-black" /> Favorite
        {isFavoritePageError && (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            Error : {favoritePageError} , Please try again later!
          </span>
        )}
        {isToggleFavoriteError && (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            Error : {toggleFavoriteError} , Please try again later!
          </span>
        )}
        {isToggleFavoriteSuccess ? (
          <span className="text-green-800 shadow-2xl rounded-md px-1">
            {toggleFavoriteMessage["message"]}
          </span>
        ) : null}
      </section>
      <section className="flex gap-x-20 gap-y-20 flex-wrap h-[86vh] overflow-y-auto p-2">
        {favoritePageData && favoritePageData.length ? (
          favoritePageData.map((item, index) => (
            <section
              key={index}
              className="w-[228px] h-[150px] bg-white rounded hover:shadow-xl cursor-pointer"
            >
              {item?.type === "folder" ? (
                <img
                  className="w-full h-full object-contain"
                  src="/graph_img/file.png"
                  alt="Folder"
                  onClick={() => handleOpenFolder(item._id)}
                />
              ) : (
                <img
                  className="w-full h-full object-contain"
                  src={item?.icon || "/placeholder.png"}
                  alt="File"
                  onClick={() =>
                    handleOpenWorkbook(item._id, item.selectedSheetId)
                  }
                />
              )}
              <div className="text-[14px] flex justify-between items-center pl-2">
                {item.name}
                <section className="flex gap-3 relative">
                  {/* {item !== null && item.favourite ? (
                    <IoIosStar
                      onClick={() => handleRemoveFromFavorite(item._id, item.type)}
                    />
                  ) : (
                    <IoIosStarOutline
                      onClick={() => handleRemoveFromFavorite(item._id, item.type)}
                    />
                  )} */}
                  <IoMdInformationCircleOutline />
                  <Dropdown
                    label={
                      <PiDotsThreeOutlineVerticalFill className="text-black cursor-pointer" />
                    }
                    placement="right-start"
                    arrowIcon={false}
                    className="flex flex-col items-center justify-left px-2 w-52"
                  >
                    <DropdownItem
                      className="flex items-center justify-start w-full text-[14px] hover:text-teal-600 pl-2 py-[2px] gap-1 truncate"
                      onClick={() =>
                        handleRemoveFromFavorite(item._id, item.type)
                      }
                    >
                      Remove from favourites{" "}
                      <RiDeleteBin6Line className="mt-[2px]" />
                    </DropdownItem>
                  </Dropdown>
                </section>
              </div>
            </section>
          ))
        ) : isLoading || isToggleFavoriteLoading ? (
          <LoadingIndicator />
        ) : (
          <div className="flex items-center justify-center h-screen  ml-[40%] ">
            <div className="flex flex-col items-center">
              <IoStarOutline className="text-9xl" />
              <h1 className="text-2xl font-medium text-gray-700 mt-4">
                You don’t have any favorites.
              </h1>
              <p className="text-gray-500 mt-2">
                To find content easily, add it to your favorites.
              </p>
            </div>
          </div>
        )}
      </section>
    </section>
  );
}
